var map = {
	"./symbol_0.png": "816e",
	"./symbol_1.png": "6c0b",
	"./symbol_2.png": "2521",
	"./symbol_3.png": "f6be",
	"./symbol_4.png": "5381",
	"./symbol_5.png": "5541",
	"./symbol_6.png": "4301",
	"./symbol_7.png": "1917",
	"./symbol_8.png": "bc89",
	"./symbol_9.png": "cfbd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aac9";